import { getRouteApi } from '@tanstack/react-router'
import { CircularProgress, Icon, IconName, IconSize, Page, PageFace, Panel } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { Footer } from 'ui/temp/Footer'

import { SalesDataSourceFileUpload } from '../../components/SalesDataSourceFileUpload'
import { SalesDataSourceForm } from '../../components/SalesDataSourceForm'
import { useBankSourceCreate } from './useBankSourceCreate'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/salesdata/bank-source-override/$mrId/$licenseId')

const BankSourceOverride = () => {
  const { mrId, licenseId } = routeApi.useParams()
  const { type } = routeApi.useSearch()

  const { data, onCancel, openSubmitConfirm, isSubmitting, files, addFiles, deleteFile, formApi } = useBankSourceCreate(
    +mrId,
    +licenseId,
    type
  )

  if (!data) {
    return <CircularProgress centered />
  }

  const { licenseNumber, titleOverline, infoPeriod } = data

  return (
    <Page
      face={PageFace.SECONDARY}
      subTitle="Manual Sales Data Override"
      title={titleOverline}
      footer={
        <Footer>
          <Button face="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button loading={isSubmitting} onClick={openSubmitConfirm} face="primary">
            Save
          </Button>
        </Footer>
      }
    >
      <Panel rounded shadowed collapsible={false} title="Add Sales Data">
        <SC.Box>
          <article>
            <h5>
              Sales Data for <strong>{infoPeriod}</strong>
            </h5>
            <h5>
              License&nbsp;
              <strong>{licenseNumber}</strong>
            </h5>
          </article>
        </SC.Box>
        <SC.StyledHr />
        <SC.BoxSection>
          <p style={{ display: 'flex', alignItems: 'center' }}>
            <Icon name={IconName.INFO} size={IconSize.S} />
            &nbsp;&nbsp;Manual Override will be the primary Sales Data source
          </p>
          <br />
          <SalesDataSourceForm formApi={formApi} />
        </SC.BoxSection>
        <SC.StyledHr />
        <SC.BoxSection>
          <article>
            <h5>Upload Documents</h5>
            <p>
              Please upload a document showing sales for <strong>{infoPeriod}</strong>
            </p>
            <SalesDataSourceFileUpload
              files={files}
              addFiles={addFiles}
              deleteFile={deleteFile}
              deleteUploadedFile={() => {}}
              uploadedFiles={[]}
            />
          </article>
        </SC.BoxSection>
      </Panel>
    </Page>
  )
}

export default BankSourceOverride
